// frontend/src/components/ProductCard.jsx
import { Link } from 'react-router-dom';
import { ShoppingCart, Heart, Star, Phone, Eye, Package, Check, MessageCircle } from 'lucide-react';
import { useCartStore } from '../store/cartStore';
import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import config from '../config';
import api from '../services/api';

// آیکون SVG واتساپ
const WhatsAppIcon = ({ className = "w-3.5 h-3.5 md:w-4 md:h-4" }) => (
  <svg 
    className={className}
    viewBox="0 0 24 24" 
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

// آیکون تلگرام
const TelegramIcon = ({ className = "w-3.5 h-3.5 md:w-4 md:h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

// آیکون سروش
const SoroushIcon = ({ className = "w-3.5 h-3.5 md:w-4 md:h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
    <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"/>
  </svg>
);

// آیکون بله
const BaleIcon = ({ className = "w-3.5 h-3.5 md:w-4 md:h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
    <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z"/>
  </svg>
);

// کامپوننت انتخاب آیکون بر اساس نوع پیام‌رسان
const MessengerIcon = ({ type, className }) => {
  switch(type) {
    case 'telegram':
      return <TelegramIcon className={className} />;
    case 'soroush':
      return <SoroushIcon className={className} />;
    case 'bale':
      return <BaleIcon className={className} />;
    case 'whatsapp':
    default:
      return <WhatsAppIcon className={className} />;
  }
};

export const ProductCard = ({ product, viewMode = 'grid' }) => {
  const addToCart = useCartStore((state) => state.addItem);
  const [isAdded, setIsAdded] = useState(false);
  const [siteSettings, setSiteSettings] = useState(null);

  // دریافت تنظیمات سایت
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await api.get('/cms/settings/get_settings/');
        setSiteSettings(response.data);
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };
    fetchSettings();
  }, []);

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();

    addToCart(product);

    toast.success(`${product.name} به سبد خرید اضافه شد`, {
      duration: 2000,
      position: 'bottom-center',
      icon: '🛒',
    });

    setIsAdded(true);
    setTimeout(() => setIsAdded(false), 2000);
  };

  // ========== تابع تماس برای قیمت ==========
  const handleContactClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const phone = product.contact_phone || siteSettings?.contact_phone || config.CONTACT_PHONE;
    window.location.href = `tel:${phone}`;
  };

  // ========== تابع ارسال پیام ==========
  const handleMessengerClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const settings = siteSettings || {};
    const messengerType = settings.messenger_type || 'whatsapp';
    const phone = settings.messenger_phone || settings.contact_phone || config.CONTACT_WHATSAPP || '';
    const username = settings.messenger_username || '';
    const link = settings.messenger_link || '';
    
    let messengerLink = link;
    
    if (!messengerLink) {
      const cleanPhone = phone.replace(/^0/, '').replace(/[^0-9]/g, '');
      
      switch(messengerType) {
        case 'whatsapp':
          messengerLink = `https://wa.me/98${cleanPhone}`;
          break;
        case 'telegram':
          messengerLink = username ? `https://t.me/${username}` : `https://t.me/${cleanPhone}`;
          break;
        case 'soroush':
          messengerLink = `https://sapp.ir/${username || cleanPhone}`;
          break;
        case 'bale':
          messengerLink = `https://bale.ai/${username || cleanPhone}`;
          break;
        case 'eitaa':
          messengerLink = `https://eitaa.com/${username || cleanPhone}`;
          break;
        case 'rubika':
          messengerLink = `https://rubika.ir/${username || cleanPhone}`;
          break;
        default:
          messengerLink = `tel:${phone}`;
      }
    }
    
    if (messengerLink) {
      window.open(messengerLink, '_blank');
    }
  };

  const formatPrice = (price) => {
    if (!price && price !== 0) return '۰';
    const numPrice = typeof price === 'string' ? parseFloat(price) : price;
    if (isNaN(numPrice)) return '۰';
    return new Intl.NumberFormat('fa-IR').format(numPrice);
  };

  const finalPrice = product.discount_price || product.price;
  const hasDiscount = product.discount_price && product.discount_price < product.price;
  const discountPercent = product.discount_percent ||
    (hasDiscount ? Math.round(((product.price - product.discount_price) / product.price) * 100) : 0);

  const showPriceOnCall = product.show_price_on_call || false;
  const settings = siteSettings || {};
  const showMessenger = settings.show_messenger_button !== false;
  const messengerType = settings.messenger_type || 'whatsapp';
  
  // نام پیام‌رسان برای نمایش
  const messengerNames = {
    'whatsapp': 'واتساپ',
    'telegram': 'تلگرام',
    'soroush': 'سروش',
    'bale': 'بله',
    'eitaa': 'ایتا',
    'rubika': 'روبیکا',
  };
  const messengerDisplayName = messengerNames[messengerType] || 'پیام';

  // ========== رندر بخش قیمت (بالا) ==========
  const renderPriceSection = () => {
    if (showPriceOnCall) {
      return (
        <div className="flex items-center gap-2">
          <span className="text-[9px] md:text-[10px] text-blue-600 font-medium bg-blue-50 px-2 py-0.5 rounded-full">
            مشاوره رایگان
          </span>
        </div>
      );
    }

    return (
      <span className="text-sm md:text-lg font-bold text-blue-600">
        {formatPrice(finalPrice)} تومان
      </span>
    );
  };

  // ============================================================
  // ✅ رندر دکمه‌های اقدام (پایین - هم‌سطح با دکمه سبد خرید)
  // ============================================================
  const renderActionButton = () => {
    if (showPriceOnCall) {
      // ========== حالت تماس برای قیمت ==========
      return (
        <div className="flex gap-1 w-full">
          <button
            onClick={handleContactClick}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-2 py-1.5 md:px-3 md:py-2 rounded-lg transition-colors text-[10px] md:text-xs flex items-center justify-center gap-1 min-h-[28px] md:min-h-[36px]"
          >
            <Phone className="w-3 h-3 md:w-3.5 md:h-3.5" />
            <span>تماس</span>
          </button>
          {showMessenger && messengerType !== 'phone_only' && (
            <button
              onClick={handleMessengerClick}
              className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-2 py-1.5 md:px-3 md:py-2 rounded-lg transition-colors text-[10px] md:text-xs flex items-center justify-center gap-1 min-h-[28px] md:min-h-[36px]"
            >
              <MessengerIcon type={messengerType} className="w-3 h-3 md:w-3.5 md:h-3.5" />
              <span>{messengerDisplayName}</span>
            </button>
          )}
        </div>
      );
    }

    // ========== حالت عادی (با قیمت) ==========
    return (
      <button
        onClick={handleAddToCart}
        disabled={product.stock === 0}
        className={`w-full flex items-center justify-center gap-1 md:gap-2 text-white px-2 py-1.5 md:px-3 md:py-2 rounded-lg transition-colors text-xs md:text-sm min-h-[28px] md:min-h-[36px] ${
          isAdded ? 'bg-green-600' : 'bg-blue-600 hover:bg-blue-700'
        } disabled:bg-gray-400 disabled:cursor-not-allowed`}
      >
        {isAdded ? (
          <>
            <Check className="w-3.5 h-3.5 md:w-4 md:h-4" />
            <span>افزوده شد</span>
          </>
        ) : (
          <>
            <ShoppingCart className="w-3.5 h-3.5 md:w-4 md:h-4" />
            <span>افزودن به سبد</span>
          </>
        )}
      </button>
    );
  };

  // ============================================================
  // حالت لیست (List View)
  // ============================================================
  if (viewMode === 'list') {
    return (
      <div className="group bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 overflow-hidden">
        <Link to={`/products/${product.slug}`} className="block">
          <div className="flex flex-col sm:flex-row gap-3 p-3 md:gap-4 md:p-4">
            {/* Image Container */}
            <div className="relative w-full sm:w-32 md:w-40 h-32 md:h-40 flex-shrink-0 overflow-hidden bg-gray-50 rounded-lg">
              <img
                src={product.main_image || '/placeholder-product.jpg'}
                alt={product.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/placeholder-product.jpg';
                }}
              />
              {hasDiscount && (
                <div className="absolute top-2 right-2 bg-red-500 text-white text-xs font-bold px-1.5 py-0.5 md:px-2 rounded-full">
                  {discountPercent}% تخفیف
                </div>
              )}
              {showPriceOnCall && (
                <div className="absolute bottom-2 left-2 bg-blue-500 text-white text-xs font-bold px-2 py-1 rounded-full">
                  تماس بگیرید
                </div>
              )}
            </div>

            {/* Content */}
            <div className="flex-1 flex flex-col sm:flex-row sm:items-center justify-between gap-3 md:gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <span className="text-xs text-blue-600 font-medium bg-blue-50 px-2 py-0.5 rounded">
                    {product.category_name || 'محصول'}
                  </span>
                  {product.brand && (
                    <span className="text-xs text-gray-500">برند: {product.brand}</span>
                  )}
                </div>

                <h3 className="font-bold text-gray-900 mb-1 md:mb-2 hover:text-blue-600 transition line-clamp-2 text-sm md:text-base">
                  {product.name}
                </h3>

                <p className="text-gray-500 text-xs md:text-sm line-clamp-2 mb-2">
                  {product.description || 'توضیحاتی برای این محصول...'}
                </p>

                <div className="flex items-center gap-2 md:gap-3 flex-wrap">
                  <div className="flex items-center gap-1">
                    <Star className="w-3 h-3 md:w-4 md:h-4 fill-yellow-400 text-yellow-400" />
                    <span className="text-xs md:text-sm text-gray-600">۴.۵</span>
                    <span className="text-xs text-gray-400">(۱۲ نظر)</span>
                  </div>
                  {product.stock > 0 ? (
                    <span className="text-xs text-green-600">موجود</span>
                  ) : (
                    <span className="text-xs text-red-600">ناموجود</span>
                  )}
                  {product.seller_name_display && (
                    <span className="text-xs text-gray-400 line-clamp-1">فروشنده: {product.seller_name_display}</span>
                  )}
                </div>
              </div>

              {/* Price & Action */}
              <div className="flex flex-row sm:flex-col items-center sm:items-end gap-2 md:gap-3">
                <div className="text-left">
                  {renderPriceSection()}
                </div>
                <div className="w-full sm:w-auto">
                  {renderActionButton()}
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    );
  }

  // ============================================================
  // حالت گرید (Grid View) - با ارتفاع ثابت
  // ============================================================
  return (
    <div className="group bg-white rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden flex flex-col h-full">
      <Link to={`/products/${product.slug}`} className="block flex-shrink-0">
        <div className="relative aspect-square overflow-hidden bg-gray-50">
          <img
            src={product.main_image || '/placeholder-product.jpg'}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/placeholder-product.jpg';
            }}
          />
          {hasDiscount && (
            <div className="absolute top-2 right-2 md:top-3 md:right-3 bg-red-500 text-white text-xs font-bold px-1.5 py-0.5 md:px-2 md:py-1 rounded-full z-10">
              {discountPercent}% تخفیف
            </div>
          )}
          {showPriceOnCall && (
            <div className="absolute bottom-2 left-2 bg-blue-500 text-white text-xs font-bold px-2 py-1 rounded-full z-10">
              تماس بگیرید
            </div>
          )}
          <button
            className="absolute top-2 left-2 md:top-3 md:left-3 p-1.5 md:p-2 bg-white/90 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-50 z-10"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <Heart className="w-3.5 h-3.5 md:w-4 md:h-4 text-gray-600 hover:text-red-500" />
          </button>
        </div>
      </Link>

      <div className="p-2 md:p-4 flex flex-col flex-grow">
        <div className="flex-grow">
          <div className="text-[10px] md:text-xs text-blue-600 font-medium mb-0.5 md:mb-1">
            {product.category_name || 'محصول'}
          </div>

          <Link to={`/products/${product.slug}`}>
            <h3 className="font-bold text-gray-900 mb-1 md:mb-2 line-clamp-2 text-xs md:text-sm leading-relaxed hover:text-blue-600 transition min-h-[2rem] md:min-h-[2.5rem]">
              {product.name}
            </h3>
          </Link>

          <div className="flex items-center justify-between mb-1 md:mb-2">
            {product.brand && (
              <span className="text-[10px] md:text-xs text-gray-500 line-clamp-1">برند: {product.brand}</span>
            )}
            {product.seller_name_display && (
              <span className="text-[10px] md:text-xs text-gray-400 line-clamp-1">{product.seller_name_display}</span>
            )}
          </div>

          <div className="flex items-center gap-1 mb-2 md:mb-3">
            <Star className="w-3 h-3 md:w-4 md:h-4 fill-yellow-400 text-yellow-400" />
            <span className="text-xs md:text-sm text-gray-600">۴.۵</span>
            <span className="text-[10px] md:text-xs text-gray-400">(۱۲ نظر)</span>
          </div>

          {/* ========== بخش قیمت (بالا) ========== */}
          <div className="flex items-center justify-between min-h-[24px] md:min-h-[32px]">
            {renderPriceSection()}
            {product.stock > 0 && product.stock < 10 && !showPriceOnCall && (
              <span className="text-[10px] md:text-xs text-orange-600">فقط {product.stock} عدد</span>
            )}
          </div>
        </div>

        {/* ========== دکمه‌های اقدام (پایین - هم‌سطح) ========== */}
        <div className="mt-2 md:mt-3 min-h-[36px] md:min-h-[44px]">
          {renderActionButton()}
        </div>
      </div>
    </div>
  );
};